//import { AddOn } from '../addon/AddOn'
import { AddOnHometel } from '../addon/AddOnHometel';
//import { AddOnHomePhone } from '../addon/AddOnHomePhone'
import { IFbbSubmissionInfo } from '../IFbbSubmissionInfo';
import { ASession } from '../../common/ASession';
import { AddOnKKBox, AddOnKKBoxPlan } from '../addon/AddOnKKBox';
import { AddOnMyTV } from '../addon/AddOnMyTV';
import { AddOnNorton, AddOnNortonPlan } from '../addon/AddOnNorton';
import { AddOnNortonVPN } from '../addon/AddOnNortonVPN';
import { AddOnRouter } from '../addon/AddOnRouter';
import { AddOnRentalRouter } from '../addon/AddOnRentalRouter';
import { AddOnRentalRouterFree } from '../addon/AddOnRentalRouterFree';
import { AddOnBuyMeshRouter } from '../addon/AddOnBuyMeshRouter';
import { AddOnRentalMeshRouter } from '../addon/AddOnRentalMeshRouter';
import { AddOnRentalRouterShort } from '../addon/AddOnRentalRouterShort';
import { AddOnAppleiPad } from '../addon/AddOnAppleiPad';
import * as log from '../../../common/js/appLogger';
import { AddOn } from '../addon/AddOn';
import { AddOnUtil } from '../addon/AddOnUtil';

export class AllAddOn extends ASession implements IFbbSubmissionInfo {
	protected sessionKey: string = 'AllAddOnService'; //selected add on service

	protected hometel: AddOnHometel | null = null;
	//protected phonehome:Array<AddOnHomePhone> | null = null
	protected kkbox: AddOnKKBox | null = null;
	protected mytv: AddOnMyTV | null = null;
	protected norton: AddOnNorton | null = null;
	protected router: AddOnRouter | null = null;
	protected rentalRouter: AddOnRentalRouter | null = null;
	protected rentalRouterFree: AddOnRentalRouterFree | null = null;
	protected rentalRouterShort: AddOnRentalRouterShort | null = null;
	protected nortonvpn: AddOnNortonVPN | null = null;
	protected ipad: AddOnAppleiPad | null = null;
	protected buyMesh: AddOnBuyMeshRouter | null = null;
	protected rentalMesh: AddOnRentalMeshRouter | null = null;

	constructor() {
		super();
		this.setData(this.getDefaultData());
		log.i('AllAddOn is created.');
	}

	//=================================================================================
	public getData(): any {
		var hometelJson = this.hometel2Json();
		var kkboxJson = this.kkbox2Json();
		var mytvJson = this.mytv2Json();
		var nortonJson = this.norton2Json();
		var routerJson = this.router2Json();
		var rentalRouterJson = this.rentalRouter2Json();
		var rentalRouterFreeJson = this.rentalRouterFree2Json();
		var rentalRouterShortJson = this.rentalRouterShort2Json();
		var nortonvpnJson = this.nortonvpn2Json();
		var ipadJson = this.ipad2Json();
		var buyMeshJson = this.buyMesh2Json();
		var rentalMeshJson = this.rentalMesh2Json();

		return {
			hometel: hometelJson,
			kkbox: kkboxJson,
			mytv: mytvJson,
			norton: nortonJson, //to be implemented
			router: routerJson,
			rentalRouter: rentalRouterJson,
			rentalRouterFree: rentalRouterFreeJson,
			rentalRouterShort: rentalRouterShortJson,
			nortonvpn: nortonvpnJson,
			ipad: ipadJson,
			buyMesh: buyMeshJson,
			rentalMesh: rentalMeshJson,
		};
	}

	protected setData(data: any) {
		this.parseHometel(data);
		this.parseKKBox(data);
		this.parseMyTV(data);
		this.parseNotron(data);
		this.parseRouter(data);
		this.parseRentalRouter(data);
		this.parseRentalRouterFree(data);
		this.parseRouterShort2Json(data);
		this.parseNotronVPN(data);
		this.parseIpad(data);

		this.parseRentalMesh(data);
		this.parseBuyMesh(data);
		//log.ot('all addon set data', data)
		//log.ot('all addon set data router', this.router)
	}

	protected getDefaultData(): any {
		return {
			hometel: { selected: false, callForward: false, speedDial: false, doNotDisturb: false },
			kkbox: { plan: AddOnKKBoxPlan.NONE },
			mytv: { selected: false },
			norton: { plan: AddOnNortonPlan.NONE }, //to be implemented
			router: { selected: false },
			rentalRouter: { selected: false },
			rentalRouterFree: { selected: false },
			rentalRouterShort: { selected: false },
			nortonvpn: { selected: false },
			ipad: { selected: false },
			buyMesh: { selected: false, count: 0 },
			rentalMesh: { selected: false, count: 0 },
		};
	}

	public addAddon(addon: AddOn) {
		//log.ot('--- addAddon', addon)
		if (addon instanceof AddOnKKBox) {
			this.kkbox = addon;
		} else if (addon instanceof AddOnHometel) {
			this.hometel = addon;
		} else if (addon instanceof AddOnMyTV) {
			this.mytv = addon;
		} else if (addon instanceof AddOnNorton) {
			this.norton = addon;
		} else if (addon instanceof AddOnRouter) {
			this.router = addon;
		} else if (addon instanceof AddOnRentalRouter) {
			this.rentalRouter = addon;
		} else if (addon instanceof AddOnRentalRouterFree) {
			this.rentalRouterFree = addon;
		} else if (addon instanceof AddOnRentalRouterShort) {
			this.rentalRouterShort = addon;
		} else if (addon instanceof AddOnNortonVPN) {
			this.nortonvpn = addon;
		} else if (addon instanceof AddOnAppleiPad) {
			this.ipad = addon;
		} else if (addon instanceof AddOnRentalMeshRouter) {
			this.rentalMesh = addon;
		} else if (addon instanceof AddOnBuyMeshRouter) {
			this.buyMesh = addon;
		}
	}

	protected hometel2Json(): any {
		var hometelJson = {
			key: 'AddOnHometel',
			selected: false,
			callForward: false,
			speedDial: false,
			doNotDisturb: false,
			isNewNum: false,
			phoneNum: null,
			isReserved: false,
			isApproved: false,
		};
		if (this.hometel == null) {
			return hometelJson;
		}
		if (!this.hometel.getIsBasePlanSelected()) {
			return hometelJson;
		}

		hometelJson.selected = this.hometel.getIsBasePlanSelected();
		hometelJson.callForward = this.hometel.isSelectedCallForward();
		hometelJson.speedDial = this.hometel.isSelectedSpeedDial();
		hometelJson.doNotDisturb = this.hometel.isSelectedDoNotDisturb();
		var tempDate = this.hometel.getData();
		hometelJson.isNewNum = tempDate.isNewNum;
		hometelJson.phoneNum = tempDate.phoneNum;
		hometelJson.isReserved = tempDate.isReserved;
		hometelJson.isApproved = this.hometel.isHometelApproved();

		return hometelJson;
	}

	protected kkbox2Json(): any {
		var json = { plan: AddOnKKBoxPlan.NONE };
		if (this.kkbox == null) {
			return json;
		}
		json.plan = this.kkbox.getPlanIndex();
		return json;
	}

	protected mytv2Json(): any {
		var json = { selected: this.mytv?.isAddOnSelected() ?? false };
		return json;
	}

	protected norton2Json(): any {
		var json = { plan: AddOnNortonPlan.NONE };
		if (this.norton == null) {
			return json;
		}
		json.plan = this.norton.getPlanIndex();
		return json;
	}

	protected router2Json(): any {
		var json = { selected: this.router?.isAddOnSelected() ?? false };
		return json;
	}

	protected rentalRouter2Json(): any {
		var json = { selected: this.rentalRouter?.isAddOnSelected() ?? false };
		return json;
	}

	protected rentalRouterFree2Json(): any {
		var json = { selected: this.rentalRouterFree?.isAddOnSelected() ?? false };
		return json;
	}

	protected rentalRouterShort2Json(): any {
		var json = { selected: this.rentalRouterShort?.isAddOnSelected() ?? false };
		return json;
	}

	protected routerShort2Json(): any {
		var json = { selected: this.rentalRouterShort?.isAddOnSelected() ?? false };
		return json;
	}

	protected nortonvpn2Json(): any {
		var json = { selected: this.nortonvpn?.isAddOnSelected() ?? false };
		return json;
	}

	protected ipad2Json(): any {
		var json = { selected: this.ipad?.isAddOnSelected() ?? false };
		return json;
	}

	protected buyMesh2Json(): any {
		var json = { selected: this.buyMesh?.isAddOnSelected() ?? false, count: 0 };
		if (this.buyMesh == null) {
			return json;
		}
		if (this.buyMesh?.getSelectedCount() <= 0) {
			json.selected = false;
			return json;
		}
		json.count = this.buyMesh?.getSelectedCount() as number;
		return json;
	}

	protected rentalMesh2Json(): any {
		var json = { selected: this.rentalMesh?.isAddOnSelected() ?? false, count: 0 };
		if (this.rentalMesh == null) {
			return json;
		}
		if (this.rentalMesh?.getSelectedCount() <= 0) {
			json.selected = false;
			return json;
		}
		json.count = this.rentalMesh?.getSelectedCount() as number;
		return json;
	}

	protected parseKKBox(data: any) {
		//log.ot('allAddon parseKKBox', data.kkbox?.plan)
		if ((data.kkbox?.plan ?? AddOnKKBoxPlan.NONE) !== AddOnKKBoxPlan.NONE) {
			this.kkbox = new AddOnKKBox();
			this.kkbox.setPlanList(data.kkbox.plan);
		} else {
			this.kkbox = null;
		}
	}

	protected parseMyTV(data: any) {
		if (data.mytv?.selected ?? false) {
			this.mytv = new AddOnMyTV();
			this.mytv.setSelectedCount(1);
		} else {
			this.mytv = null;
		}
	}

	protected parseRouter(data: any) {
		if (data.router?.selected ?? false) {
			this.router = new AddOnRouter();
			//log.it('..>>>', (data.router?.selected ?? false))
			this.router.setSelectedCount(1);
		} else {
			this.router = null;
		}
	}

	protected parseRentalRouter(data: any) {
		if (data.rentalRouter?.selected ?? false) {
			this.rentalRouter = new AddOnRentalRouter();
			//log.it('..>>>', (data.rentalRouter?.selected ?? false))
			this.rentalRouter.setSelectedCount(1);
		} else {
			this.rentalRouter = null;
		}
	}

	protected parseRentalRouterFree(data: any) {
		// rentalRouterFree
		if (data.rentalRouterFree?.selected ?? false) {
			this.rentalRouterFree = new AddOnRentalRouterFree();
			//log.it('..>>>', (data.rentalRouterFree?.selected ?? false))
			this.rentalRouterFree.setSelectedCount(1);
		} else {
			this.rentalRouterFree = null;
		}
	}

	protected parseBuyMesh(data: any) {
		// buyMesh
		if ((data.buyMesh?.selected ?? false) && data.buyMesh.count > 0) {
			this.buyMesh = new AddOnBuyMeshRouter();
			this.buyMesh.setSelectedCount(data.rentalMesh.count);
		} else {
			this.buyMesh = null;
		}
	}

	protected parseRentalMesh(data: any) {
		// rentalMesh
		if ((data.rentalMesh?.selected ?? false) && data.rentalMesh.count > 0) {
			this.rentalMesh = new AddOnRentalMeshRouter();
			this.rentalMesh.setSelectedCount(data.rentalMesh.count);
		} else {
			this.rentalMesh = null;
		}
	}

	protected parseRouterShort2Json(data: any) {
		// rentalRouterRebateFree
		if (data.rentalRouterShort?.selected ?? false) {
			this.rentalRouterShort = new AddOnRentalRouterShort();
			//log.it('..>>>', (data.rentalRouterFree?.selected ?? false))
			this.rentalRouterShort.setSelectedCount(1);
		} else {
			this.rentalRouterShort = null;
		}
	}

	protected parseNotronVPN(data: any) {
		if (data.nortonvpn?.selected ?? false) {
			this.nortonvpn = new AddOnNortonVPN();
			//log.it('..>>>', (data.router?.selected ?? false))
			this.nortonvpn.setSelectedCount(1);
		} else {
			this.nortonvpn = null;
		}
	}

	protected parseNotron(data: any) {
		if ((data.norton?.plan ?? AddOnNortonPlan.NONE) !== AddOnNortonPlan.NONE) {
			this.norton = new AddOnNorton();
			this.norton.setPlanList(data.norton.plan);
		} else {
			this.norton = null;
		}
	}

	protected parseIpad(data: any) {
		if (data.ipad?.selected ?? false) {
			this.ipad = new AddOnAppleiPad();
			log.it('..>>>', data.ipad?.selected ?? false);
			this.ipad.setSelectedCount(1);
		} else {
			this.ipad = null;
		}
	}

	protected parseHometel(data: any) {
		if (data.hometel?.selected ?? false) {
			this.hometel = new AddOnHometel();
			this.hometel.setIsBasePlanSelected(true);
			if (data.hometel.callForward) {
				this.hometel.setCallForward(true);
			}
			if (data.hometel.speedDial) {
				this.hometel.setSpeedDial(true);
			}
			if (data.hometel.doNotDisturb) {
				this.hometel.setDoNotDisturb(true);
			}

			this.hometel.parse({
				isNewNum: data.hometel.isNewNum,
				phoneNum: data.hometel.phoneNum,
				isReserved: data.hometel.isReserved,
				isApproved: data.hometel.isApproved,
			});
		} else {
			this.hometel = null;
		}
	}

	public parseJson(addonJson: any) {
		var list = this.getAddonList();
		for (var addon of list) {
			var j = AddOnUtil.findJson(addonJson, addon.getKey());
			addon.parseConfig(j);
		}
	}

	public getAddonList(): Array<AddOn> {
		// eslint-disable-next-line
		var ary: Array<AddOn> = new Array();
		if (this.hometel != null) {
			ary.push(this.hometel);
		}
		if (this.kkbox != null) {
			ary.push(this.kkbox);
		}
		if (this.mytv != null) {
			ary.push(this.mytv);
		}
		if (this.norton != null) {
			ary.push(this.norton);
		}
		if (this.router != null) {
			ary.push(this.router);
		}
		if (this.rentalRouter != null) {
			ary.push(this.rentalRouter);
		}
		if (this.rentalRouterFree != null) {
			ary.push(this.rentalRouterFree);
		}
		if (this.rentalRouterShort != null) {
			ary.push(this.rentalRouterShort);
		}
		if (this.nortonvpn != null) {
			ary.push(this.nortonvpn);
		}
		if (this.ipad != null) {
			ary.push(this.ipad);
		}
		if (this.buyMesh != null) {
			ary.push(this.buyMesh);
		}
		if (this.rentalMesh != null) {
			ary.push(this.rentalMesh);
		}
		return ary;
	}

	public getGTMAddOnList(): string {
		var addons = this.getAddonList() ?? [];

		var gtmAddonList = '';
		for (var addon of addons) {
			if (addon instanceof AddOnRouter) {
				gtmAddonList += (gtmAddonList.length > 0 ? ',' : '') + 'Router';
			} else if (addon instanceof AddOnRentalRouter) {
				gtmAddonList += (gtmAddonList.length > 0 ? ',' : '') + 'RentalRouter';
			} else if (addon instanceof AddOnRentalRouterFree) {
				gtmAddonList += (gtmAddonList.length > 0 ? ',' : '') + 'RentalRouterFree';
			} else if (addon instanceof AddOnRentalRouterShort) {
				gtmAddonList += (gtmAddonList.length > 0 ? ',' : '') + 'RentalRouterShort';
			} else if (addon instanceof AddOnKKBox) {
				gtmAddonList += (gtmAddonList.length > 0 ? ',' : '') + 'KKBox';
			} else if (addon instanceof AddOnNorton) {
				gtmAddonList += (gtmAddonList.length > 0 ? ',' : '') + 'Norton';
			} else if (addon instanceof AddOnMyTV) {
				gtmAddonList += (gtmAddonList.length > 0 ? ',' : '') + 'MyTV';
			} else if (addon instanceof AddOnHometel) {
				gtmAddonList += (gtmAddonList.length > 0 ? ',' : '') + 'Hometel';
			} else if (addon instanceof AddOnNortonVPN) {
				gtmAddonList += (gtmAddonList.length > 0 ? ',' : '') + 'NortonVPN';
			} else if (addon instanceof AddOnAppleiPad) {
				gtmAddonList += (gtmAddonList.length > 0 ? ',' : '') + 'AppleiPad';
			} else if (addon instanceof AddOnBuyMeshRouter) {
				gtmAddonList += (gtmAddonList.length > 0 ? ',' : '') + 'BuyMeshRouter';
			} else if (addon instanceof AddOnRentalMeshRouter) {
				gtmAddonList += (gtmAddonList.length > 0 ? ',' : '') + 'RentalMeshRouter';
			}
		}
		return gtmAddonList;
	}

	//=================================================================================
}
